<div class="welcome-screen">
  <!-- todo add mobile and choose -->

  <!-- desktop -->
  <div class="desktop-wrapper xs:!hidden">
    <div class="description">
      <ng-container *ngTemplateOutlet="mainHeader"></ng-container>
      <ng-container *ngTemplateOutlet="mainDescription"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="mainButton"></ng-container>
  </div>

  <!-- mobile -->
  <div class="mobile-wrapper gt-xs:!hidden">
    <ng-container *ngTemplateOutlet="mainHeader"></ng-container>
    <ng-container *ngTemplateOutlet="mainDescription"></ng-container>
    <ng-container *ngTemplateOutlet="mainButton"></ng-container>
  </div>

  <!-- instructions -->
  <div class="instruction">
    <!-- clear -->
    <div class="instruction__entry">
      <p class="instruction__entry__header">
        <img icon class="eraser-icon" src="assets/icons/eraser.svg" />
        {{ 'DIAGNOSTICS.EXTENDED_PARAMETER.WELCOME_SCREEN.CLEAR_CHART.HEADER' | translate }}
      </p>
      <p class="instruction__entry__text">
        {{ 'DIAGNOSTICS.EXTENDED_PARAMETER.WELCOME_SCREEN.CLEAR_CHART.DESCRIPTION' | translate }}
      </p>
    </div>
    <!-- save -->
    <div class="instruction__entry">
      <p class="instruction__entry__header">
        <mat-icon>save</mat-icon>
        {{ 'DIAGNOSTICS.EXTENDED_PARAMETER.WELCOME_SCREEN.SAVE_DATA.HEADER' | translate }}
      </p>

      <p class="instruction__entry__text">
        {{ 'DIAGNOSTICS.EXTENDED_PARAMETER.WELCOME_SCREEN.SAVE_DATA.DESCRIPTION' | translate }}
      </p>
    </div>
    <!-- delete -->
    <div class="instruction__entry">
      <p class="instruction__entry__header">
        <mat-icon>delete</mat-icon>
        {{ 'DIAGNOSTICS.EXTENDED_PARAMETER.WELCOME_SCREEN.REMOVE_TILE.HEADER' | translate }}
      </p>
      <p class="instruction__entry__text">
        {{ 'DIAGNOSTICS.EXTENDED_PARAMETER.WELCOME_SCREEN.REMOVE_TILE.DESCRIPTION' | translate }}
      </p>
    </div>
    <!-- no infographic -->
    <div class="instruction__entry">
      <p class="instruction__entry__header">
        <img icon class="crossed-out-icon" src="assets/icons/graph-crossed-out.svg" />
        {{ 'DIAGNOSTICS.EXTENDED_PARAMETER.WELCOME_SCREEN.NO_INFOGRAPHIC.HEADER' | translate }}
      </p>
      <p class="instruction__entry__text">
        {{ 'DIAGNOSTICS.EXTENDED_PARAMETER.WELCOME_SCREEN.NO_INFOGRAPHIC.DESCRIPTION' | translate }}
      </p>
    </div>
  </div>
</div>

<ng-template #mainHeader>
  <h2 class="description__header">
    {{ 'DIAGNOSTICS.EXTENDED_PARAMETER.WELCOME_SCREEN.HEADER' | translate }}
  </h2>
</ng-template>

<ng-template #mainDescription>
  <p class="description__text">
    {{ 'DIAGNOSTICS.EXTENDED_PARAMETER.WELCOME_SCREEN.DESCRIPTION' | translate }}
  </p>
</ng-template>

<ng-template #mainButton>
  <div class="button-wrapper">
    <button
      class="add-button"
      data-at-add-parameter
      mat-raised-button
      color="primary"
      gtm="onOpen"
      gtmAction="Add parameter from welcome screen"
      gtmCategory="diagnosticsPage"
      (click)="openModal()"
    >
      <mat-icon>add</mat-icon>
      <span>
        {{
          useCasesSelected
            ? ('DIAGNOSTICS.EXTENDED_PARAMETER.WELCOME_SCREEN.ADD_USE_CASE' | translate)
            : ('DIAGNOSTICS.EXTENDED_PARAMETER.WELCOME_SCREEN.ADD_PARAMETER' | translate)
        }}
      </span>
    </button>
  </div>
</ng-template>
